let Home = () => import('../pages/Home');
let ProductDetails = () => import('../pages/ProductDetails');
let ProductBatch = () => import('../pages/ProductBatch');
let ProductListing = () => import('../pages/ProductListing');
let TrackOrder = () => import('../pages/TrackOrder');
let AllCategories = () => import('../pages/AllCategories');
let AllDigitalPrinting = () => import('../pages/AllDigitalPrinting');
let AllOffsetPrinting = () => import('../pages/AllOffsetPrinting');
let AllLargeformatPrinting = () => import('../pages/AllLargeformatPrinting');
let EcoPrinting = () => import('../pages/EcoPrinting');
let AllBrands = () => import('../pages/AllBrands');
let AllOffers = () => import('../pages/AllOffers');
let OfferDetails = () => import('../pages/OfferDetails');
let AllBlogs = () => import('../pages/AllBlogs');
let BlogDetails = () => import('../pages/BlogDetails');
let Portfolios = () => import('../pages/Portfolios');
let PortfolioDetails = () => import('../pages/PortfolioDetails');
let Boards = () => import('../pages/Boards');
let BoardDetails = () => import('../pages/BoardDetails');
let CompanyLocation = () => import('../pages/company/Location');

export default [
    {
        path: '',
        component: Home,
        name: 'Home',
        meta: { requiresAuth: false },
    },
    {
        path: '/all-categories',
        component: AllCategories,
        name: 'AllCategories',
        meta: { requiresAuth: false },
    },
    {
        path: '/all-digital-printing',
        component: AllDigitalPrinting,
        name: 'AllDigitalPrinting',
        meta: { requiresAuth: false },
    },
    {
        path: '/all-offset-printing',
        component: AllOffsetPrinting,
        name: 'AllOffsetPrinting',
        meta: { requiresAuth: false },
    },
    {
        path: '/all-largeformat-printing',
        component: AllLargeformatPrinting,
        name: 'AllLargeformatPrinting',
        meta: { requiresAuth: false },
    },
    {
        path: '/eco-printing',
        component: EcoPrinting,
        name: 'EcoPrinting',
        meta: { requiresAuth: false },
    },
    {
        path: '/all-brands',
        component: AllBrands,
        name: 'AllBrands',
        meta: { requiresAuth: false },
    },
    {
        path: '/all-offers',
        component: AllOffers,
        name: 'AllOffers',
        meta: { requiresAuth: false },
    },
    {
        path: '/offer/:offerSlug?',
        component: OfferDetails,
        name: 'OfferDetails',
        meta: { requiresAuth: false },
    },
    {
        path: '/shop',
        component: ProductListing,
        name: 'Shop',
        meta: { requiresAuth: false },
    },
    {
        path: '/category/:categorySlug?',
        component: ProductListing,
        name: 'Category',
        meta: { requiresAuth: false },
    },
    {
        path: '/brand/:brandId?',
        component: ProductListing,
        name: 'Brand',
        meta: { requiresAuth: false },
    },
    {
        path: '/search/:keyword?',
        component: ProductListing,
        name: 'Search',
        meta: { requiresAuth: false },
    },
    {
        path: '/product/:slug',
        component: ProductDetails,
        name: 'ProductDetails',
        meta: { requiresAuth: false },
    },
    {
        path: '/product-batch/:slug',
        component: ProductBatch,
        name: 'ProductBatch',
        meta: { requiresAuth: false },
    },
    {
        path: '/track-order',
        component: TrackOrder,
        name: 'TrackOrder',
        meta: { requiresAuth: true },
    },
    {
        path: '/all-blogs',
        component: AllBlogs,
        name: 'AllBlogs',
        meta: { requiresAuth: false },
    },
    {
        path: '/all-blogs/category/:categorySlug?',
        component: AllBlogs,
        name: 'AllBlogsFilter',
        meta: { requiresAuth: false },
    },
    {
        path: '/all-blogs/search/:searchKeyword?',
        component: AllBlogs,
        name: 'SearchBlogs',
        meta: { requiresAuth: false },
    },
    {
        path: '/blog-details/:slug',
        component: BlogDetails,
        name: 'BlogDetails',
        meta: { requiresAuth: false },
    },

    {
        path: '/portfolios',
        component: Portfolios,
        name: 'Portfolios',
        meta: { requiresAuth: false },
    },
    {
        path: '/portfolios/category/:categorySlug?',
        component: Portfolios,
        name: 'PortfolioFilter',
        meta: { requiresAuth: false },
    },
    {
        path: '/portfolios/search/:searchKeyword?',
        component: Portfolios,
        name: 'SearchPortfolio',
        meta: { requiresAuth: false },
    },
    {
        path: '/portfolio-details/:slug',
        component: PortfolioDetails,
        name: 'PortfolioDetails',
        meta: { requiresAuth: false },
    },
    {
        path: '/boards',
        component: Boards,
        name: 'Boards',
        meta: { requiresAuth: false },
    },
    {
        path: '/boards/category/:categorySlug?',
        component: Boards,
        name: 'BoardFilterByCategory',
        meta: { requiresAuth: false },
    },
    {
        path: '/boards/search/:searchKeyword?',
        component: Boards,
        name: 'SearchBoard',
        meta: { requiresAuth: false },
    },
    {
        path: '/board-details/:slug',
        component: BoardDetails,
        name: 'BoardDetails',
        meta: { requiresAuth: false },
    },

    {
        path: '/company/location',
        component: CompanyLocation,
        name: 'CompanyLocation',
        meta: { requiresAuth: false },
    },
];
